import SEO from "@/components/SEO";
import ContactHero from "./components/ContactHero";
import ContactInfoSection from "./components/ContactInfoSection";
import SocialMediaSection from "./components/SocialMediaSection";
import SupportSection from "./components/SupportSection";
import { useSiteSettings, type ContactSettings } from "@/lib/siteSettings";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const buildContactSchema = (contact: ContactSettings) => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "聯絡我們｜TAIAA 台灣 AI 應用推廣協會",
  description:
    "與 TAIAA 取得聯繫、洽詢合作或支持協會發展。協會會址、電子郵件與社群資訊。",
  url: siteUrl ? `${siteUrl}/contact` : undefined,
  mainEntity: {
    "@type": "Organization",
    name: "TAIAA 台灣 AI 應用推廣協會",
    url: siteUrl || undefined,
    email: contact.email,
    telephone: contact.phone || undefined,
    address: {
      "@type": "PostalAddress",
      streetAddress: contact.address,
      addressCountry: "TW",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "一般諮詢",
      email: contact.email,
      availableLanguage: ["Chinese", "English"],
    },
  },
});

export default function Contact() {
  const { settings } = useSiteSettings();
  const contactSchema = buildContactSchema(settings.contact);
  return (
    <main className="pt-0">
      <SEO
        title="聯絡我們｜TAIAA 台灣 AI 應用推廣協會"
        description="與 TAIAA 取得聯繫、洽詢合作或支持協會發展。協會會址、電子郵件與社群資訊。"
        keywords="TAIAA,聯絡我們,AI 合作,協會地址,電子郵件"
        schema={contactSchema}
      />
      <ContactHero />
      <ContactInfoSection />
      <SocialMediaSection />
      <SupportSection />
    </main>
  );
}